import React, {useRef, useState} from 'react';
import logo from '../static/logo.png';
import config from '../config';
import {Menu, Dropdown, Avatar, message, notification, Button } from 'antd';
import {useNavigate, useLocation} from 'react-router-dom';
import SvgIcon from '../components/svgIcon/index';
import {CaretDownOutlined} from '@ant-design/icons';
import { connect } from 'react-redux'
import FormModal from "../components/FormModal";
import {user} from "../api";

const menuOption = config.authPages;

function AdminHeader(props) {
    const FormModalRef = useRef();
    const [current, setCurrent] = useState([menuOption[0].key]);
    const [name, setName] = useState('-');
    const [title, setTitle] = useState('物联网商用平台');
    const [LogoImage, setLogoImage] = useState(null);
    const [socket, setSocket] = useState(null);
    const [heartbeatInterval, setHeartbeatInterval] = useState(null);
    const [menus, setMenus] = useState([]);
    const navigation = useNavigate();
    const location = useLocation();

    const openNotification = (data) => {
        const key = `orderMessage`;
        const btn = (
            <Button type="primary" size="small" onClick={() => {
                notification.close(key);
                navigation(`/orderInfo/${data.OrderId}`)
            }}>
                查看详情
            </Button>
        );
        notification['warning']({
            message: '发生告警',
            description: data.Content,
            btn,
            key,
            onClose: () => {
                notification.close(key)
            },
        });
    };
    const startWs = ({UserId}) => {
        if(UserId === "67d491a08b77a879e58eff45") {
            const socket = new WebSocket('ws://120.27.3.148:10315/ws');
            socket.onopen = () => {
                console.log('链接WS成功');
                // 每 10 秒发送心跳包
                const heartbeatInterval = setInterval(() => {
                    if (socket.readyState === WebSocket.OPEN) {
                        console.log('发送心跳');
                        socket.send(JSON.stringify({
                            type: 'heartbeat',
                            timestamp: Date.now()
                        }));
                    }
                }, 5000); // 10 秒间隔
                setHeartbeatInterval(heartbeatInterval)
            };
            socket.onmessage = (event) => {
                console.log('Message from server ', JSON.parse(event.data));
                openNotification(JSON.parse(event.data));
            };
            socket.onerror = (error) => {
                if(heartbeatInterval) {
                    clearInterval(heartbeatInterval);
                }
                console.error('WebSocket error: ', error);
                startWs({UserId})
            };
            socket.onclose = () => {
                console.log("链接关闭");
            };
            setSocket(socket);
        }
    };

    React.useEffect(() => {
        setMenus(props.Pages)
        let {MapInfo, UserInfo} = props;
        if(MapInfo){
            setLogoImage(MapInfo.LogoImage)
            setTitle(MapInfo.ShowPageTitle)
        } else {
            setLogoImage(logo)
            setTitle('物联网商用平台')
        }
        if(UserInfo) {
            setName(UserInfo.RealName);
            startWs(UserInfo);
        }
        if(location.pathname === '/') {
            navigation('/index')
        }

        return () => {
            socket.close();
            clearInterval(heartbeatInterval);
        };
    }, [])
    React.useEffect(() => {
        let path = location.pathname + location.search;
        if(path !== '/404') {
            setCurrent([path.replace('/', '')]);
        }
    }, [location]);
    const userMenu = (
        <Menu onClick={({key}) => {
            console.log(key);
            switch (key) {
                case "logut":
                    props.clearUserInfo();
                    if(socket) {
                        socket.close();
                        clearInterval(heartbeatInterval);
                    }
                    navigation('/login')
                    break;
                case "userInfo":
                    FormModalRef.current.open('修改密码', {
                        submit: async (data, call, errcall) => {
                            if (data.newPwd !== data.cnewPwd) {
                                message.warning('两次密码不一致！');
                                errcall();
                                return;
                            }
                            let responseData = {
                                ...data,
                            }
                            let {Status, Message} = await user.UpdatePwd(responseData);
                            if (Status === 10001) {
                                message.success('更改成功！');
                                call();
                            } else {
                                message.warning(Message);
                                errcall();
                            }
                        },
                        rules: {
                            oldPwd: [{required: true, message: '请输入旧密码'}],
                            newPwd: [{required: true, message: '请输入新密码'}],
                            cnewPwd: [{required: true, message: '请确认新密码'}],
                        },
                        labelCol: {style: {width: '6em'}},
                        list: [
                            {label: '密码', prop: 'oldPwd'},
                            {label: '新密码', prop: 'newPwd'},
                            {label: '确认密码', prop: 'cnewPwd'},
                        ]
                    })
                    break;
            }
        }}>
            <Menu.Item key="userInfo">
                修改密码
            </Menu.Item>
            <Menu.Item key="logut">
                退出登录
            </Menu.Item>
        </Menu>
    );
    const HandleClick = e => {
        if(e.key.indexOf('http://') === 0 || e.key.indexOf('https://') === 0) {
            window.open(e.key)
        } else {
            navigation(`/${e.key}`)
        }
    };

    const renderItem = (menus) => {
        return menus.map(value => {
            if(!value) {
                return null
            }
            if (value.Pages && value.Pages.filter(v => v).length) {
                return (
                    <Menu.SubMenu key={value.WebPageId}
                                  title={value.Name}>
                        {
                            renderItem(value.Pages)
                        }
                    </Menu.SubMenu>
                )
            } else  {
                return (
                    <Menu.Item key={value.Path}>
                        {value.Name}
                    </Menu.Item>
                )
            }
        })
    }

    return (
        <div className="header">
            <FormModal ref={FormModalRef}/>
            <div className="header-logo">
                {
                    LogoImage && <img src={LogoImage} alt=""/>
                }
                {title}
            </div>
            <div className="header-menu">
                <Menu onClick={HandleClick} selectedKeys={current} mode="horizontal">
                    {
                        renderItem(menus)
                    }
                </Menu>
            </div>
            <div className="header-opt">
                <div className="header-opt-screen" onClick={() => {
                    window.open(`${window.location.origin}/screen`)
                }}>
                    <span><SvgIcon iconClass="screen"/> </span>数据投屏
                </div>
                <Dropdown overlay={userMenu}>
                    <div className="header-opt-logout">
                        <Avatar src="https://joeschmoe.io/api/v1/random"/>
                        <span>
                            {name}<CaretDownOutlined/>
                        </span>
                    </div>
                </Dropdown>
            </div>
        </div>
    )
}

const stateToProps = (state) =>{
    return{
        UserInfo: state.UserInfo,
        MapInfo: state.MapInfo,
        Pages: state.Pages.map((value, key) => {
            value.WebPageId =  value.WebPageId ? value.WebPageId : 'page-' + key;
            value.Name =  value.Title;
            return value;
        }),
    }
}

const dispathToProps = (dispatch) =>{
    return{
        clearUserInfo(){
            const action ={
                type:'clearUserInfo',
            }
            dispatch(action)
        },
    }
}

export default connect(stateToProps, dispathToProps)(AdminHeader);
